module.exports = __webpack_public_path__ + "static/media/Grant Niven.65c18085.jpg";